export default "__VITE_ASSET__3a23389b__"